// src/App.js
import React from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './services/auth/AuthContext';
import ProtectedRoute from './services/auth/ProtectedRoute';
import Dashboard from './pages/dashboard/dashboard';
import MyProfileDashboard from './pages/dashboard/components/profile/myProfile';
import SignIn from './pages/sign-in/SignIn';
import ResellerSignIn from './pages/sign-in/ResellerSignIn';
import PartnerLogin from './pages/sign-in/PartnerSignIn';
import Register from './pages/sign-up/register';
import KYCRegistration from './pages/sign-up/kyc';
import BankAccountInfo from './pages/onboarding/bank_account_info';
import ESignPage from './pages/onboarding/esign';
import Home from './pages/home';
import SearchCustomer from './pages/dashboard/components/dashboard/tabs/SearchCustomer';
import CreateEnquiryPage from './pages/dashboard/components/create-enquiry';
import LiveChatScreen from './pages/dashboard/components/support/LiveChat';
import CallbacksPage from './pages/dashboard/components/support/Callbacks';
import NotFound from './pages/NotFound';
import CustomizedSnackbarProvider from './providers/CustomizedSnackbarProvider';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CustomizedSnackbarProvider>
        <CssBaseline enableColorScheme />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="sign-in" element={<SignIn />} />
            <Route path="reseller-sign-in" element={<ResellerSignIn />} />
            <Route path="partner-sign-in" element={<PartnerLogin />} />
            <Route
              path="dashboard"
              element={<ProtectedRoute element={<Dashboard />} />}
            />
            <Route
              path="register"
              element={<ProtectedRoute element={<Register />} />}
            />
            <Route
              path="kyc"
              element={<ProtectedRoute element={<KYCRegistration />} />}
            />
            <Route
              path="onboarding"
              element={<ProtectedRoute element={<BankAccountInfo />} />}
            />
            <Route
              path="esign"
              element={<ProtectedRoute element={ <ESignPage />} />}
            />
            <Route
              path="profile"
              element={<ProtectedRoute element={<MyProfileDashboard />} />}
            />
            <Route
              path="search"
              element={<ProtectedRoute element={<SearchCustomer />} />}
            />
            <Route
              path="create-enquiry"
              element={
                <ProtectedRoute
                  element={<CreateEnquiryPage />}
                  allowedRoles={['support', 'partner', 'bc_partner','connector', 'rm']}
                />
              }
            />
            <Route
              path="support"
              element={
                <ProtectedRoute
                  element={<LiveChatScreen />}
                  allowedRoles={['support']}
                />
              }
            />
            <Route
              path="callbacks"
              element={
                <ProtectedRoute
                  element={<CallbacksPage />}
                  allowedRoles={['support']}
                />
              }
            />
            {/* The wildcard route for 404 Not Found */}
            <Route path="*" element={<NotFound/>} />
          </Routes>
        </AuthProvider>
      </CustomizedSnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
